import { Link } from "react-router-dom";
import Seo from "../components/Seo";

export default function NotFoundPage() {
  return (
    <>
      <Seo title="Page not found" description="The requested page is not part of the public Medein website." />
      <section className="not-found">
        <p className="section-label">404</p>
        <h1>This signal ends here.</h1>
        <p>The page may have moved or is not part of the public site.</p>
        <Link className="button button-primary" to="/">Return home</Link>
      </section>
    </>
  );
}
